type TypeActionNameWithTo = {
  name: string
  to: string
  icon: string
}

type PortletTitleCrudType = {
  create: TypeActionNameWithTo
  read: TypeActionNameWithTo
  readContractProgress: TypeActionNameWithTo
  update: TypeActionNameWithTo
  delete: TypeActionNameWithTo
}
export type ClientData = {
  cpf: string
  created_at: string
  deleted_at?: string
  email: string
  id: number
  name: string
  status: string
  type: string
  values?: string
  updated_at: string
}

export type ContractProgressData = {
  id: number
  cpf: string
  name: string
  payment_form: string
  status: string
  values: number
  created_at: string
  updated_at: string
  deleted_at?: string
}

const nameEntity = 'ContractProgress'
const nameSource = 'commercial/contractProgress'
const namePageTitle = 'Progresso do contrato'
const nameActionPageMain: TypeActionNameWithTo = {
  name: 'Progresso do contrato',
  to: '/commercial/contractProgress',
  icon: ''
}

const nameActions: PortletTitleCrudType = {
  create: {
    name: 'Adicionar',
    to: '/commercial/contractProgress/create/',
    icon: 'fa fa-plus'
  },
  read: {
    name: 'Visualizar',
    to: '/commercial/contractProgress/',
    icon: 'fa fa-list'
  },
  readContractProgress: {
    name: 'Contratos',
    to: '/commercial/contractProgress/',
    icon: 'fa fa-list'
  },
  update: {
    name: 'Editar',
    to: '/commercial/contractProgress/update/',
    icon: 'fa fa-edit'
  },
  delete: {
    name: 'Remover',
    to: '#!',
    icon: 'fa fa-remove'
  }
}

export {
  nameEntity,
  nameSource,
  namePageTitle,
  nameActionPageMain,
  nameActions
}
